import React from 'react';
import LineStroke from '../individual-components/line-stroke';
import PropTypes from 'prop-types'
import EventsScroll from './events-scroll';
import EventsList from '@/assets/data/events.json'

// Note : This is the events obj format
// {
//     "link": "http://hyqoo.com/events/01",
//     "image": "/images/event01.webp",
//     "categories": ["AI", "Machine Learning", "Technology"],
//     "title": "TechTalk on Vertex AI Vision",
//     "location": "Bgl, India",
//     "schedule": "June 8th at 3:00 PM "
//  }

const Events = ({ context }) => {
    return (
        EventsList?.length ?
            <section className='relative z-10 flex flex-col justify-center w-full md:px-4 mx-auto md:mb-4 md:text-center px-8 max-w-7xl text-left mb-6'>
                <div className='w-56 mx-auto sm:w-full mb-5'>
                    <LineStroke />
                </div>
                <h1 className="w-full mx-auto mb-6 text-3xl text-center leading-none font-bold">
                    {context?.header}
                </h1>

                <div className='md:hidden w-full md:grid-cols-1 mb-8 grid grid-cols-3 gap-x-6 xl:gap-x-10 gap-y-8 last:mb-0'>
                    {(EventsList || [])?.map((event, index) => (
                        <EventCard key={event?.title} event={event} />
                    ))}
                </div>

                <EventsScroll events={EventsList} />
            </section>
            : null
    );
};

export const EventCard = ({ event }) => (
    <a href={event?.link || "#"} className="flex flex-col w-full md:max-w-md mx-auto bg-white border rounded-lg shadow-lg group max-w-none mb-8">
        <img className="object-cover w-full rounded-t-lg" src={event?.image} alt={event?.title} />
        <div className="flex flex-col items-start justify-center w-full p-6 text-left gap-2">
            <div className="flex w-full flex-wrap gap-2">
                {(event?.categories || [])?.map((category, i) => (
                    <div key={category + i} className="text-sm text-[#3730A3] bg-[#E0E7FF] font-semibold px-3 py-0.5 rounded-full">
                        {category}
                    </div>
                ))}
            </div>

            <div className="flex items-start justify-between gap-8">
                <div className="w-full md:text-lg font-semibold text-xl group-hover:underline">
                    {event?.title || '---'}
                </div>
            </div>

            {event?.location ?
                <div className="relative w-fit font-semibold flex gap-2.5 text-base text-[#667085]">
                    <svg className="stroke-[#667085]" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.99998 10.4166C9.38069 10.4166 10.5 9.29734 10.5 7.91663C10.5 6.53591 9.38069 5.41663 7.99998 5.41663C6.61927 5.41663 5.49998 6.53591 5.49998 7.91663C5.49998 9.29734 6.61927 10.4166 7.99998 10.4166Z" stroke="current" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M7.99998 18.3333C9.66665 15 14.6666 12.8485 14.6666 8.33329C14.6666 4.65139 11.6819 1.66663 7.99998 1.66663C4.31808 1.66663 1.33331 4.65139 1.33331 8.33329C1.33331 12.8485 6.33331 15 7.99998 18.3333Z" stroke="current" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                    {event.location}
                </div> : null
            }

            {event?.schedule ?
                <div className="relative w-fit font-semibold flex gap-2.5 text-base text-[#667085]">
                    <svg className="stroke-[#667085]" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 4.99996V9.99996L13.3334 11.6666M18.3334 9.99996C18.3334 14.6023 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6023 1.66669 9.99996C1.66669 5.39759 5.39765 1.66663 10 1.66663C14.6024 1.66663 18.3334 5.39759 18.3334 9.99996Z" stroke="current" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                    {event.schedule}
                </div> : null
            }
        </div>
    </a>
)

EventCard.propTypes = {
    event: PropTypes.object
}

export default Events;
